/**
 * Creates a promise object that can be resolved or rejected manually
 */
export const createPromise = () => {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return {
        promise,
        resolve: resolve,
        reject: reject,
    };
};
//# sourceMappingURL=createPromise.js.map